import './_empty-services.scss';
import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { ReactComponent as Empty } from './empty.svg';
import { ReactComponent as EmptyDarkMode } from './empty-dark-mode.svg';

const EmptyTable = ({ description, children }) => {
  const { darkMode } = useSelector((state) => state.general);

  return (
    <tr>
      <td colSpan={500}>
        <div className="custom-table__empty-items">
          <div className="custom-table__empty-items-cell">
            {children || (
              <div className="custom-table__empty-items-default">
                <div className="custom-table__empty-items-default-content">
                  <div className="custom-table__empty-items-default-icon">
                    {darkMode ? <EmptyDarkMode /> : <Empty />}
                  </div>
                  <div className="custom-table__empty-items-default-description">
                    <div>{description}</div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </td>
    </tr>
  )
}

EmptyTable.defaultProps = {
  description: 'Table is empty',
}

EmptyTable.propTypes = {
  description: PropTypes.string,
  children: PropTypes.object,
}

export default EmptyTable;
